import { logAmplitudeEvent } from 'amplitude/amplitude'
import { authSelectors } from 'ducks/auth'
import useTrackComponent from 'hooks/eventTracking/useTrackComponent'
import { StyledNavLinkProps } from 'layout/headers/elements/StyledNavLink'
import useTranslateWithVariable from 'projectSections/hooks/useTranslateWithVariable'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { ActionType } from 'types/tracking'

const useNavigationLinkClick = () => {
  const history = useHistory()
  const userId = useSelector(authSelectors.getCurrentUserId)
  const location = useLocation()
  const translate = useTranslateWithVariable()

  const { trackUserInteraction } = useTrackComponent({
    componentKey: 'os_navbar',
    eventName: 'os_navbar_click',
  })

  return useCallback(
    ({ label, to, value }: Pick<StyledNavLinkProps, 'label' | 'to' | 'value'>) => {
      const eventName = `nav_${value}_clicked`
      trackUserInteraction(
        { type: ActionType.CLICK },
        {
          eventName,
          user_id: userId,
          timestamp: new Date().toISOString(),
          page_from: location.pathname,
        }
      )

      if (value === 'shop' && to === '/shop') {
        logAmplitudeEvent('hardware_navigation_button', {
          context: 'marketplace_shop_entry',
        })
      }

      history.push({
        pathname: to,
        state: {
          confirmNavigationHeading: translate('Leave Project to %{label}?', { label: translate(label) }),
        },
      })
    },
    [userId, location.pathname, translate, trackUserInteraction, history]
  )
}

export default useNavigationLinkClick
